export const collapseUnusedFloatingFooterSpacerSx = {
    '& .ids-modal-content > .MuiBox-root:empty': { height: 0 }
};
